import React from 'react';
import { Box } from '@mui/material';
import { ClassroomSelect } from '../ClassroomSelect';
import { PeriodSelect } from '../PeriodSelect';
import { SubjectSelect } from '../SubjectSelect';

/**
 * Componente de filtros para a página de notas.
 * Usa os mesmos componentes e contratos da página Grades antiga
 * para evitar mudanças de comportamento.
 */
export const GradesFilters = ({
  anoLetivo,
  setAnoLetivo,
  classrooms,
  setClassrooms,
  period,
  setPeriod,
  subject,
  setSubject,
  subjects,
}) => {
  return (
    <Box sx={{ 
      display: 'flex', 
      gap: 2, 
      flexWrap: 'nowrap', 
      marginBottom: 0,
      flex: 1,
      alignItems: 'center',
      justifyContent: 'space-between',
      '@media (max-width: 1200px)': {
        flexWrap: 'wrap',
        justifyContent: 'flex-start',
      },
      '@media (max-width: 768px)': {
        flexDirection: 'column',
        width: '100%',
      }
    }}>
      <ClassroomSelect
        anoLetivo={anoLetivo}
        classrooms={classrooms}
        setClassrooms={setClassrooms}
      />

      <PeriodSelect
        period={period}
        setPeriod={setPeriod}
      />

      <SubjectSelect
        subject={subject}
        setSubject={setSubject}
        subjects={subjects}
      />
    </Box>
  );
};

